export const buttonFunctionalityClasses = {
  ENABLE: 'text-purple cursor-pointer fill-purple',
  DISABLE: 'text-gray cursor-not-allowed fill-gray',
  MOBILE_NEXT_ENABLE: 'cursor-pointer bg-[#5C41FF]',
  MOBILE_PREV_ENABLE: 'cursor-pointer bg-[#2E2E2E]',
  MOBILE_DISABLE: 'cursor-not-allowed bg-gray',
};
